import React from 'react'

export function Header () {
    return <div className="header">
        <h1>Mineral Quiz</h1>
    </div>
    }